 /*
 * chrome offer
 * @version 2.3 {separate file}
 * @copyright AVAST Software a.s.
 * @namespace avast.mkt
 * @author Mirek Ratman, Pepa Cala, Ales Gabriel <gabriel@avast.com>
 * @since 2013-07, parts from 2012,2013 script
 * @require mkt.js
 *used on LPs
 */

if( typeof jQuery != 'undefined' && typeof avast.mkt != 'undefined' ) {

	avast.mkt.chromebox = avast.mkt.prototype = {

		/*
		 * Object with global params for best antyvirus comparison
		 */
		conf : {
			boxClassname		: '.chromebox',
			boxChrome			: '.box-gc:not(#offer-chrome)',
			boxChromeButton		: '.box-gc .button',
			boxFMS				: '.box-fms'
		},


		/*
		 * Method for hide chrome banner if there is information that user is opening page in chrome, or have chrome.
		 * @method handle
		 */
		handle : function(){
			var pExt = $(document).getUrlParam('p_ext');
			var isChrome = navigator.userAgent.toLowerCase().indexOf('chrome') > -1;

			var url = document.location.href;
			if (url.indexOf("?")>-1){
				url = url.substr(0,url.indexOf("?"));
			}/*url without parameters*/

			if(!pExt) { pExt = ''; }

		if($(avast.mkt.chromebox.conf.boxChrome).length > 0 && !(pExt.toLowerCase().indexOf('chrome') > -1 || isChrome)) {

			$(avast.mkt.chromebox.conf.boxChrome).css("display","block");
			if( $(avast.mkt.chromebox.conf.boxFMS).length > 0 ){
				$(avast.mkt.chromebox.conf.boxFMS).css("display","none");
			}

				// Chrome offer banner viewed
				window.dataLayer = window.dataLayer || [];
				dataLayer.push({
					'event' : 'chromeOffer', 
					'eventCategory' : 'Chrome',
					'eventAction' : 'Chrome Offer',
					'eventLabel' : 'View'
				});				

			$(avast.mkt.chromebox.conf.boxChromeButton).on("click", function(e){				
				window.dataLayer = window.dataLayer || [];
				dataLayer.push({
					'event' : 'chromeOffer', 
					'eventCategory' : 'Chrome',
					'eventAction' : 'Chrome Offer',
					'eventLabel' : 'Click'
				});
			});
		}

		}
	};
}